import { render } from "./visi_misi.vue?vue&type=template&id=1d34dd2a"
import script from "./visi_misi.vue?vue&type=script&lang=js"
export * from "./visi_misi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__